// Storage access throws when the browser blocks site data; the app must still
// render, so a blocked store reads as empty and writes are dropped.
export const getLocalStorageItem = <T extends string>(
  key: string,
): T | null => {
  try {
    return window.localStorage.getItem(key) as T;
  } catch {
    return null;
  }
};

export const updateLocalStorageItem = (key: string, payload: string | null) => {
  try {
    if (payload === null || payload === "null") {
      window.localStorage.removeItem(key);
    } else {
      window.localStorage.setItem(key, payload);
    }
  } catch {
    // storage unavailable
  }
};
